import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { IconButton } from "@components/molecules/iconButton";
import { Icon } from "@components/atoms/icons";

const columnHelper = createColumnHelper<{
  email: string;
  phone: string;
  isEmail: boolean;
}>();

export const useEmailColumns = (
  onDelete?: ({
    type,
    value,
  }: {
    value: string;
    type: "email" | "phone";
  }) => void,
) => {
  const { t } = useTranslation(["form"]);

  const actionColumn = onDelete
    ? [
        columnHelper.accessor("email", {
          id: "deleteAction",
          header: t("action"),
          cell({ row }) {
            return (
              <IconButton
                icon={<Icon name={"TrashBinTrash"} color={"danger-main"} />}
                noTooltip
                transparent
                label={""}
                onClick={() =>
                  onDelete({
                    value: row.original.email || row.original.phone,
                    type: row.original.isEmail ? "email" : "phone",
                  })
                }
              />
            );
          },
        }),
      ]
    : [];

  return [
    columnHelper.accessor("email", {
      header: t("emailPhone"),
      cell: ({ getValue }) => (
        <div dir={"ltr"} style={{ direction: "ltr" }}>
          {getValue()}
        </div>
      ),
    }),
    ...actionColumn,
  ];
};
